import { GenericCollectionFactory } from "../_generics";
import { AvantioAccommodation } from "../_modelsTS/Integration";

export const AvantioStore = GenericCollectionFactory<AvantioAccommodation>("AVANTIO-INTEGRATION", "id");
